import uuidv4 from 'uuid/v4';
import { includes } from 'lodash';

import urls from '../constants/urls';

import { gatherErrors } from '../utils/errorHandling';

import { requestPasswordResetToken } from './passwordResets';

export const LOADING_USERS = 'users/LOADING_USERS';
export const USERS_LOAD_SUCCESS = 'users/USERS_LOAD_SUCCESS';
export const USERS_LOAD_FAILED = 'users/USERS_LOAD_FAILED';

export const CREATING_USER = 'users/CREATING_USER';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'users/CREATE_USER_FAILED';

export const REGISTERING = 'users/REGISTERING';
export const REGISTRATION_SUCCESS = 'users/REGISTRATION_SUCCESS';
export const REGISTRATION_FAILED = 'users/REGISTRATION_FAILED';
export const REGISTRATION_FAILED_DUE_TO_TERMS = `${REGISTRATION_FAILED}_TERMS`;

const initialState = {
  users: [],
  registeredEmail: '',

  createErrors: {},

  failedLoading: false,

  hasLoaded: false,

  isLoading: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_USERS:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case USERS_LOAD_SUCCESS:
      return {
        ...state,
        users: action.payload.data,
        total: action.payload.headers['x-total'],
        pages: action.payload.headers['x-pages'],
        page: action.payload.headers['x-page'],
        isLoading: false,
        failedLoading: false,
        hasLoaded: true,
      };

    case USERS_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case CREATING_USER:
      return {
        ...state,
        isSaving: true,
        failedSaving: false,
        createErrors: {},
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createErrors: {},
        isSaving: false,
      };

    case CREATE_USER_FAILED:
      return {
        ...state,
        isSaving: false,
        failedSaving: true,
        createErrors: gatherErrors(action.error, 'create_user_failed'),
      };

    case REGISTERING:
      return {
        ...state,
        isSaving: true,
        failedSaving: false,
        createErrors: {},
        registeredEmail: null,
      };

    case REGISTRATION_SUCCESS:
      return {
        ...state,
        isSaving: false,
        createErrors: {},
        registeredEmail: action.meta.previousAction.email,
      };

    case REGISTRATION_FAILED:
      return {
        ...state,
        isSaving: false,
        failedSaving: true,
        createErrors: gatherErrors(action.error, 'create_user_failed'),
      };

    case REGISTRATION_FAILED_DUE_TO_TERMS:
      return {
        ...state,
        isSaving: false,
        failedSaving: true,
        createErrors: action.errors,
      };

    default:
      return state;
  }
};

export const loadUsers = (page, searchTerm) => dispatch => {
  return dispatch({
    types: [LOADING_USERS, USERS_LOAD_SUCCESS, USERS_LOAD_FAILED],
    payload: {
      request: {
        url: urls.users.index,
        params: { page, search_string: searchTerm },
      },
    },
  });
};

export const loadUsersForpbrnVerification = (page, searchTerm) => dispatch => {
  return dispatch({
    types: [LOADING_USERS, USERS_LOAD_SUCCESS, USERS_LOAD_FAILED],
    payload: {
      request: {
        url: urls.users.pbrnVerification.index,
        params: { page, search_string: searchTerm },
      },
    },
  });
};

export const createUser = params => dispatch => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  const randomCharacter = alphabet[
    Math.floor(Math.random() * alphabet.length)
  ].toUpperCase();
  const userParams = {
    banned_from_messaging: params.banned_from_messaging,
    email: params.email,
    email_approved_for_messaging: params.email_approved_for_messaging,
    first_name: params.first_name,
    last_name: params.last_name,
    password: uuidv4() + randomCharacter,
    pbrn_type: params.pbrn_type,
    professional_body_registration_number:
      params.professional_body_registration_number,
    role: params.role,
    grade: params.grade,
    validate_role_and_grade_presence: true,
    rank: params.rank,
  };

  let promise = dispatch({
    types: [CREATING_USER, CREATE_USER_SUCCESS, CREATE_USER_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.users.create,
        data: { user: userParams },
      },
    },
  });

  promise.then(() => {
    requestPasswordResetToken(
      {
        email: params.email,
      },
      true
    )(dispatch);
  });

  return promise;
};

const dispatchRegisterUser = (dispatch, params) => {
  const userParams = {
    email: params.email,
    first_name: params.first_name,
    last_name: params.last_name,
    password: params.password,
    password_confirmation: params.password_confirmation,
    pbrn_type: params.pbrn_type,
    professional_body_registration_number:
      params.professional_body_registration_number,
    role: params.role,
    grade: params.grade,
    validate_role_and_grade_presence: true,
  };

  return dispatch({
    types: [REGISTERING, REGISTRATION_SUCCESS, REGISTRATION_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.users.create,
        data: { user: userParams },
      },
    },
    email: userParams.email,
  });
};

const dispatchUntickedTermsBox = dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: REGISTRATION_FAILED_DUE_TO_TERMS,
      errors: {
        terms_and_conditions: [
          'You must accept the Terms and Conditions to proceed',
        ],
      },
    });
  });
};

export const register = params => dispatch => {
  if (includes(params.terms_and_conditions, 'accepted')) {
    return dispatchRegisterUser(dispatch, params);
  }

  return dispatchUntickedTermsBox(dispatch);
};
